import {
    QueryClient,
    type UseQueryOptions,
    type UseMutationOptions,
    type DefaultOptions,
    type UseInfiniteQueryOptions,
} from '@tanstack/react-query';

import { type GeneralAxiosError } from 'src/types';

const queryConfig: DefaultOptions = {
    queries: {
        refetchOnWindowFocus: false,
        retry: false,
    },
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });

export type ExtractFnReturnType<FnType extends (...args: any) => any> = Awaited<ReturnType<FnType>>;

export type QueryConfig<
    QueryFnType extends (...args: any) => any,
    TError = GeneralAxiosError<ExtractFnReturnType<QueryFnType>>,
    TData = ExtractFnReturnType<QueryFnType>,
> = Omit<UseQueryOptions<ExtractFnReturnType<QueryFnType>, TError, TData>, 'queryKey' | 'queryFn'>;

export type InfiniteQueryConfig<
    QueryFnType extends (...args: any) => any,
    TError = GeneralAxiosError<ExtractFnReturnType<QueryFnType>>,
    TData = ExtractFnReturnType<QueryFnType>,
> = Omit<UseInfiniteQueryOptions<ExtractFnReturnType<QueryFnType>, TError, TData>, 'queryKey' | 'queryFn'>;

export type MutationConfig<
    MutationFnType extends (...args: any) => any,
    TError = GeneralAxiosError<ExtractFnReturnType<MutationFnType>>,
> = UseMutationOptions<ExtractFnReturnType<MutationFnType>, TError, Parameters<MutationFnType>[0]>;
